<template>
<div class='forget'>
    
    <el-form
     :model="loginForm"
     label-width="120px"
     :rules="loginRules"
     auto-complete="on"
     label-position="right"
     ref="loginForm">
        <!-- <h3 style='fontSize: 20px;textAlign:center'>忘记密码</h3> -->
        
        <!-- 登录账号 -->
        <el-form-item label="账号邮箱" prop='email'>
            <el-input v-model="loginForm.email" placeholder="请输入账号信息"></el-input>
            <el-button style='float: right' type="primary" :disabled='this.vcodebtn' @click="openEmail">{{verification}}</el-button>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item label="验证码" prop='vcode'>
            <el-input v-model="loginForm.vcode" placeholder="请输入验证码"></el-input>
        </el-form-item>

        <!-- 修改密码 -->
        <el-form-item label="修改密码" prop='password'>
            <el-input type="password" v-model="loginForm.password" placeholder="密码不小于五位"></el-input>
        </el-form-item>

        <!-- 确认密码 -->
        <el-form-item label="确认密码" prop='checkPass'>
            <el-input type="password" v-model="loginForm.checkPass" placeholder="请再次输入密码"></el-input>
        </el-form-item>
    </el-form>    
    <div class='submintbtn'>
        <el-button type="primary" @click='submint' :loading="loading">确定</el-button>
        <el-button type="primary" @click="cancelForget">取消</el-button>
    </div>
</div>
    
</template>

<script>
import { userSendemail, userResetpassword } from '../../services/login/register'
export default {
    data() {
        const validatePass = (rule, value, callback) => {
            if (value) {
                if (value.length < 5) {
                    callback(new Error('密码不能小于5位'))
                } else {
                    callback()
                }
            } else {
                    callback(new Error('密码不能为空'))
            }
            
        };
        const validateAgainPass = (rule, value, callback) => {
            if (value) {
                if (this.loginForm.password === value) {
                    callback()
                } else {
                    callback(new Error('输入密码错误'))
                }
            } else {
                callback(new Error('请再次输入密码'))
            }
        };
        return {
            formName: "loginForm",
            loginForm: {},
            loginRules: {
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'change' }
                ],
                password: [{required: true, trigger: 'blur', validator: validatePass}],
                checkPass: [{required: true, trigger: 'blur', validator: validateAgainPass}],
                vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            vcodebtn: false,
            loading: false,
            verification: '发送验证码',
            disabled: false,
            timer: null,
        }
    },
    methods: {
        openEmail() { // 发送验证码
            if (this.loginForm.email) {
                let params = {
                    email: this.loginForm.email
                }
                userSendemail(params).then(
                    res => this.$message.success(res.message),
                    err => this.$message.error(err.message)
                )
                this.vcodebtn = true;
                this.auth_time = 60;
                this.verification = '已发送('+ this.auth_time  +')'
                this.timer =  setInterval(() => {
                    this.auth_time--;
                    this.verification = '已发送('+ this.auth_time  +')'
                    if(this.auth_time <= 0){
                        this.vcodebtn = false;
                        this.verification = '发送验证码'
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.$message.error('请输入邮箱')
            }
        },
        submint() { // 点击重置密码
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    // setTimeout(() => {
                    //         this.$message.success('注册成功')
                    //         this.$emit('changetitle', 'login')
                    //         this.loading = false
                    // }, 2000)
                    userResetpassword(this.loginForm).then(
                        res => {
                            this.$message.success('密码修改成功')
                            this.$emit('changetitle', 'login')
                            this.loading = false
                        },
                        err => this.$message.error(err.message)
                    )
                } else {
                    return false
                }
            })
        },
        cancelForget(){
            this.$emit('changetitle', 'login')
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" <style lang="scss" scoped>
    .forget{
        padding: 0 75px;
        box-sizing: border-box;
        /deep/ .el-form {
            margin: 40px 0;
            position: relative;
            .el-form-item__label {
                font-size: 20px;
            }
            .el-form-item {
                margin-top: 40px;
                font-size: 18px;
                .el-input--mini {
                        font-size: 18px;
                    }
            }
            .el-button {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .submintbtn {
            margin-top: 40px;
            text-align: center;
            /deep/ .el-button {
                width: 200px;
                height: 36px;
                font-size: 14px;
                margin-bottom: 20px;
            }
            display: flex;
            justify-content: space-between;
        }
    }
</style>
